import { Button, Modal } from "antd"
import React from "react"
import { FileText, CheckCircle, Shield } from "lucide-react"
import { useNavigate } from "react-router-dom"
import { saveRXModal } from "../imagepath"
import { useMessageApi } from "../../services/message api/MessageProvider"

const SaveRXModal = () => {
  const [showSuccessModal, setShowSuccessModal] = React.useState(true)
  const messageApi = useMessageApi();

  const navigate = useNavigate()

  const handleModalClose = () => {
    setShowSuccessModal(false)
     messageApi.success("Appointment Consulted Successfully")
    navigate("/doctor-dashboard") // 👈 Redirect after closing
  }
    React.useEffect(() => {
    const timer = setTimeout(() => {
      handleModalClose()
    }, 1000); // ⏱️ Auto-close after 1 second

    return () => clearTimeout(timer)
  }, []);

  return (
    <Modal
      open={showSuccessModal}
      onCancel={handleModalClose}
      footer={null}
      maskClosable={false} 
        keyboard={false}
      centered
      closable={true}
      width={400}
    >
      <div className="text-center py-6">
        <div className="mb-4 flex justify-center">
          <div className="relative">
            <div className="w-16 h-16 bg-red-100 rounded-lg flex items-center justify-center">
              <img
                src={saveRXModal}
                alt="Save RX Modal"
                className="object-contain"
                style={{ width: "100px", height: "100px" }}
              />
            </div>

            {/* <div className="absolute -bottom-1 -right-1 w-6 h-6 bg-green-500 rounded-full flex items-center justify-center">
              <CheckCircle className="w-4 h-4 text-white" />
            </div> */}
          </div>
        </div>

        <h2 className="text-xl font-bold mb-2">
          {"You've successfully created prescription"}
        </h2>

        <p className="text-gray-600 mb-6 text-sm">
          {/* The prescription has been sent to patient over SMS and also made
          available on the{" "}
          <span className="text-blue-600 font-medium">Docon patient app</span> */}
        </p>

        <Button
          type="primary"
          size="large"
          onClick={handleModalClose}
          className="w-32 mb-3"
        >
          Done
        </Button>
        <hr></hr>

        <div className="flex items-center justify-center mt-6 text-xs text-gray-500 text-muted">
          <Shield className="w-4 h-4 mr-2 text-yellow-500" />
          Our Hospytl platform has undergone regular security assessments to
          ensure your data is secure.
        </div>
      </div>
    </Modal>
  );
}

export default SaveRXModal
